import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "prefixCls", "verticalAlign", "tagName", "color", "type", "spin", "style"];
import React from 'react';
import svgPaths from '@uiw/icons/fonts/w-icon.json';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
var Icon = props => {
  var {
      className,
      prefixCls = 'w-icon',
      verticalAlign = 'middle',
      tagName: Element = 'span',
      color,
      type,
      spin = false,
      style
    } = props,
    reset = _objectWithoutPropertiesLoose(props, _excluded);
  var svg = null;
  if (typeof type === 'string') {
    svg = /*#__PURE__*/_jsx("svg", {
      fill: color || props.fill,
      viewBox: "0 0 20 20",
      children: (svgPaths[type] || []).map((d, i) => /*#__PURE__*/_jsx("path", {
        d: d,
        fillRule: "evenodd"
      }, i))
    });
  }
  var initStyle = _extends({
    fill: 'currentColor'
  }, style);
  var cls = [prefixCls, className, prefixCls && verticalAlign ? prefixCls + "-" + verticalAlign : null, spin && prefixCls ? prefixCls + "-spin" : null].filter(Boolean).join(' ').trim();
  return /*#__PURE__*/_jsx(Element, _extends({
    className: cls
  }, reset, {
    style: initStyle,
    children: svg
  }));
};
export default Icon;